import React from 'react';
import { useDigitalCardState } from 'src/components/_common/DigitalCard/_hooks/useDigitalCard';
import styled from 'styled-components';

/**
 * [라이트 효과]
 *
 * @description
 * 라이트 효과는 마우스 포인트에서 원형 그라데이션을 생성하여 빛을 발산하는 효과입니다.
 * 이미지 로드 전에는 렌더링되지 않습니다.
 */
const LightEffect = () => {
  const { isAllResourcesLoaded } = useDigitalCardState();

  if (!isAllResourcesLoaded) return null;
  return <StyledLightEffect />;
};

export default LightEffect;

const StyledLightEffect = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    var(--card-width) circle at var(--light-x, 50%) var(--light-y, 50%),
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.15) 6%,
    rgba(0, 0, 0, 0.1) 100%
  );
  z-index: 10;
  opacity: var(--light-opacity, 0);
  transition: opacity 0.3s;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
`;
